import React from 'react';
import { TemplateMap } from 'components/shared/TemplateMap';

interface TemplateMapProps {
  templateId?: string;
}

const TemplateMapPage: React.FC<TemplateMapProps> = ({ templateId }) => {
  return <TemplateMap templateId={templateId} variant="freight" />;
};

export default TemplateMapPage;
